export const UNSUBSCRIBE_GROUP_ROUTE = {
  DEFAULT: '',
  name: 'unsubscribegroup/:groupId',
  route(groupId: string): string[] {
    return ['/', 'unsubscribegroup', groupId];
  }
};
